import { render, staticRenderFns } from "./need-pay.vue?vue&type=template&id=97ff4e9c&"
import script from "./need-pay.vue?vue&type=script&lang=js&"
export * from "./need-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports